import { SvgCommonProperties } from '../../interfaces/svg.interfaces';

export default function DeliveryTruckSvg(props: SvgCommonProperties) {
  return (<svg
     height={props.height}
  xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6"
>
  <path
    d="M9 17h5V5H1v12h3.5m16 0h2v-3.34a4 4 0 00-1.17-2.83L19 9h-5v8h2"
  ></path>
  <circle cx="7" cy="17.5" r="2.5"></circle>
  <circle cx="18" cy="17.5" r="2.5"></circle>
</svg>
  );
}